import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { ProjectModel, SmartSearchToolsetSettings } from '../../../../../../gamma-api';
import { defaultApi } from '../../../../../apis';
import { getProjectPath } from '../../../../../utils/pathUtils';
import IbButton from '../../../../../components/common/IbButton';
import IbIcon from '../../../../../components/common/IbIcon';

import { ACTION_CLASS_NAME } from './const';
import BaseToolsetListItem from './BaseToolsetListItem';

import { IToolsetListItemProps } from './index';

const SmartSearchToolset: React.FC<IToolsetListItemProps> = ({ toolset, onSetup, onDelete, onToolsetStateChange }) => {
  const { push } = useHistory();

  const [loading, setLoading] = useState(false);
  const [project, setProject] = useState<ProjectModel>();

  const settings = toolset.settings as SmartSearchToolsetSettings;

  const fetchProject = async () => {
    try {
      setLoading(true);
      const response = await defaultApi.getOneProjectGeneralProjectsProjectIdGet(settings.project_id);
      setProject(response.data);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => void fetchProject(), [settings.project_id]);

  const renderAction = () => {
    const onSmartSearchToolsetButtonClick = () => push(getProjectPath(toolset.folder_id, settings.project_id));
    return (
      <IbButton
        className={ACTION_CLASS_NAME}
        icon={<IbIcon iconName="efferent-four" />}
        type="icon"
        onClick={onSmartSearchToolsetButtonClick}
      />
    );
  };

  const getToolCount = () => {
    let toolCount = 0;
    settings.query_tool_settings.enabled && toolCount++;
    settings.search_documents_tool_settings.enabled && toolCount++;
    settings.download_document_tool_settings.enabled && toolCount++;
    return toolCount;
  };

  return (
    <BaseToolsetListItem
      action={renderAction()}
      loading={loading}
      name={project?.name}
      toolCount={getToolCount()}
      toolset={toolset}
      onDelete={onDelete}
      onSetup={onSetup}
      onToolsetStateChange={onToolsetStateChange}
    />
  );
};

export default SmartSearchToolset;
